<footer class="layout-grid layout-grid--row-gap">
  <!-- Non-edit mode: standard list -->
  @if (!editMode) {
    <ul class="footer__container">
      @if (!footerLinks || footerLinks.length === 0) {
        <li class="footer__block">
          <div class="skeleton-anchor">&nbsp;</div>
        </li>
        <li class="footer__block">
          <div class="skeleton-anchor">&nbsp;</div>
        </li>
      }
      @for (item of footerLinks; track trackByFooterLink($index, item)) {
        <li class="footer__block">
          <a [href]="item.url" target="_blank">{{ item.title }}</a>
        </li>
      }
    </ul>
  }

  <!-- Edit mode: sortable drag-drop list (single cdkDropList per Angular CDK canonical pattern) -->
  @if (editMode) {
    <ul
      class="footer__container"
      cdkDropList
      [cdkDropListOrientation]="'horizontal'"
      (cdkDropListDropped)="editChange.emit({field: 'footerLinksDropped', event: $event})">
      @for (item of footerLinks; track trackByFooterLink(i, item); let i = $index) {
          <li class="footer__block edit-mode site-editor-draggable" cdkDrag>
            <!-- Edit mode controls -->
            <app-edit-controls customClass="footer-item-controls"
              [showLinkIcon]="true"
              [dragHandleTitle]="'Reorder ' + item.title + ' (use arrow keys)'"
              [linkIconTitle]="'Edit URL: ' + item.url"
              [deleteTitle]="'Delete footer link: ' + item.title"
              [linkEditField]="'footerLinks[' + i + '].url'"
              [linkEditValue]="item.url"
              [linkEditEnabled]="editMode"
              [linkEditConfig]="{ type: 'text', placeholder: 'Enter URL...' }"
              [linkEditError]="footerLinkUrlErrors[i]"
              (linkEditChange)="editChange.emit({field: $event.field, value: $event.value, index: i})"
              (deleteClick)="editChange.emit({field: 'deleteFooterLink', index: i})"
              (reorder)="editChange.emit({field: 'reorderFooterLink', index: i,
                direction: $event.direction})"></app-edit-controls>
            <!-- Edit mode elements -->
            <span class="editable-footer-title"
              [appInlineEdit]="'footerLinks[' + i + '].title'"
              [inlineEditValue]="item.title"
              [inlineEditEnabled]="editMode"
              [inlineEditConfig]="{ type: 'text', placeholder: 'Enter link text...' }"
              (inlineEditChange)="editChange.emit({field: $event.field, value: $event.value, index: i})"
              [class.inline-editable-error]="footerLinkTitleErrors[i]"
              tabindex="0">
              @if (item.title && item.title.trim() !== '') {
                <span>{{ item.title }}</span>
              }
              @if ((!item.title || item.title.trim() === '') && editMode) {
                <span class="placeholder-text">Click to add link text...</span>
              }
            </span>
          </li>
      }
      <!-- Add new footer link button (only in edit mode) -->
      <li class="footer__block preview-edit-block">
        <button matButton="filled" (click)="editChange.emit({field: 'addFooterLink'})">
          <mat-icon>add</mat-icon>
          Add Footer Link
        </button>
      </li>
    </ul>
  }
  <div class="footer__container footer__container--legal">
    <p class="legal-text">Powered by Teller Online</p>
    @if (!preview) {
      <a routerLink="/privacy-policy" target="_blank">Privacy Policy</a>
    }
    @if (preview) {
      <span>Privacy Policy</span>
    }
  </div>
</footer>